import { useMemo } from "react";
import {
  useGetRouteAlerts,
  formattedRouteAlerts,
} from "./clientDashboard.utils";

function Container({ children }) {
  return (
    <div className="tw-flex tw-flex-col tw-h-full paper-panel tw-px-6 tw-pt-6 tw-pb-4 tw-overflow-auto">
      <h4 className="tw-text-center tw-mb-4">Route Alerts</h4>
      <div className="tw-flex-grow">{children}</div>
    </div>
  );
}

function RouteAlerNotification() {
  const { data: response, isLoading, isError } = useGetRouteAlerts();

  const routeAlerts = useMemo(
    () => formattedRouteAlerts(response?.data),
    [response?.data]
  );

  if (isLoading)
    return (
      <Container>
        <div className="tw-flex tw-justify-center tw-items-center tw-h-full">
          <div className="spinner-border text-primary" role="status" />
        </div>
      </Container>
    );

  if (isError)
    return (
      <Container>
        <div className="tw-flex tw-justify-center tw-items-center tw-h-full tw-text-red-500">
          Issue finding route alerts
        </div>
      </Container>
    );

  if (routeAlerts.length === 0)
    return (
      <Container>
        <div className="tw-flex tw-justify-center tw-items-center bg-route-alert tw-flex-grow-1 tw-rounded tw-h-44 tw-max-h-full">
          No Route Alerts!
        </div>
      </Container>
    );

  return (
    <Container>
      <div className="tw-flex tw-flex-col tw-gap-y-4 tw-mb-12">
        {routeAlerts?.map((routeAlert, index) => (
          <div className="bg-route-alert tw-px-4 tw-pt-3 tw-pb-5" key={index}>
            <div className="tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between">
              <div className="tw-font-semibold">{routeAlert?.subject}</div>
              <div className="tw-font-semibold">{routeAlert?.entered}</div>
            </div>
            <div className="tw-col-span-2">{routeAlert?.route}</div>
            <div className="tw-col-span-2">{routeAlert?.e_Body}</div>
          </div>
        ))}
      </div>
    </Container>
  );
}

export default RouteAlerNotification;
